function getLensEl() {
  const lensEl = document.createElement("div");
  lensEl.classList.add("lens");

  return lensEl;
}

// Получение элемента загрузки
function getSpinnerEl() {
  const spinnerEl = document.createElement('div');
  spinnerEl.classList.add('intro-spinner');

  for (let i = 0; i <= 12; i++) {
    const divEl = document.createElement('div');
    spinnerEl.appendChild(divEl);
  }

  return spinnerEl;
}


export {
  getLensEl,
  getSpinnerEl
}